import { Response, dateOrNull } from "../../../index";

interface ProcessProps {
	type: UserProcessType | SystemProcessType;
	status: ProcessStatus;
	createdAt: Date | null;
	updatedAt: Date | null;
	createdBy: string;
	error?: Response;
	output?: any;
	input?: any;
	internalId?: string;
	externalId?: string;
	expiresAt?: Date | null;
}

class Process {
	constructor(public _: ProcessProps) {}

	static fromFirestore(doc: any) {
		const data = doc.data();
		return new Process({
			type: data.type,
			status: data.status,
			createdAt: dateOrNull(data.created_at),
			updatedAt: dateOrNull(data.updated_at),
			createdBy: data.created_by,
			error: data.error,
			output: data.output,
			input: data.input,
			internalId: doc.id,
			externalId: data.external_id,
			expiresAt: dateOrNull(data.expires_at),
		});
	}

	toJson() {
		const json = {
			type: this._.type,
			status: this._.status,
			created_at: this._.createdAt,
			updated_at: this._.updatedAt,
			created_by: this._.createdBy,
			error: this._.error?.toJson(),
			output: this._.output,
			input: this._.input,
			external_id: this._.externalId,
			expires_at: this._.expiresAt,
		} as any;
		for (const key in json) {
			if (json[key] === undefined) {
				delete json[key];
			}
		}
		return json;
	}

	copyWith(props: Partial<ProcessProps>) {
		return new Process({ ...this._, ...props });
	}
}

enum UserProcessType {
	POST_CREATE_ACCOUNT = "post_create_account",
	ON_CHECKOUT = "on_checkout",
	OAUTH_CONNECT = "oauth_connect",
}

enum SystemProcessType {
	BILLING = "billing",
}

enum ProcessStatus {
	IN_QUEUE = "in_queue",
	PROCESSING = "processing",
	SUCCESS = "success",
	ERROR = "error",
}

export { Process, UserProcessType, ProcessStatus, SystemProcessType };
